import httpsService from "../../services/https-service";
import controlConfig from "../../configs/control.config.json";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
    loading: false,
    data: null,
    error: "",
};

export const fetchSandboxResult = createAsyncThunk("sandboxResult/fetchSandboxResult", async () => {
    try {
        const res = await httpsService.send("get", "experiment", "result", {
            limit_num: controlConfig["get_results_limit"],
        });
        if (res.data.indicator) {
            console.log(res.data.content);
            return res.data;
        }
        console.log(res.data.message);
    } catch (error) {
        console.log(error);
    }
});

const sandboxResultSlice = createSlice({
    name: "sandboxResult",
    initialState,
    reducers: {
        emptyTheResults: (state) => {
            state.data = [];
        },
        addNewResult: (state, action) => {
            const newResult = action.payload;
            if (state.data?.length >= controlConfig["results_running_limit"]) {
                const newStateData = [newResult, ...state.data].slice(
                    0,
                    controlConfig["limit_results"]
                );
                state.data = newStateData;
                return;
            }
            state.data = [newResult, ...state.data];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSandboxResult.pending, (state) => {
            state.loading = true;
            return state;
        });
        builder.addCase(fetchSandboxResult.fulfilled, (state, action) => {
            if (action.payload.indicator) {
                if (Array.isArray(action.payload.content)) {
                    const sortedResultsArr = action.payload.content.sort((a, b) => {
                        return moment(b.event_time).diff(moment(a.event_time));
                    });
                    console.log(sortedResultsArr);
                    state.data = action.payload.content;
                }
                state.loading = false;
            } else {
                console.log(action.payload.message);
                state.error = action.payload.message;
                state.loading = false;
            }
            return state;
        });
        builder.addCase(fetchSandboxResult.rejected, (state, action) => {
            state.error = action.error.message;
            state.loading = false;
            return state;
        });
    },
});

export const { emptyTheResults, addNewResult } = sandboxResultSlice.actions;
export default sandboxResultSlice.reducer;
